<template>
	<div id="jobShadowing">
		<div class="container">


			<div class="companyInfoIpt">
				<!-- <div class="titleContainer">
					<div class="shu">
					</div>
					<div class="title">
						百万学生探岗报名
					</div>
				</div> -->
				<!-- <img src="../img/jobShadowing1.png" alt=""
					style="width: 700px;height: 150px;margin-bottom: 30px;cursor: pointer;"  /> -->
				<div class="bg"  @click="openPDF">
					<div class="title">
						学生访企探岗报名
					</div>
					<div class="subheading">
						<div class="">
							活动介绍
						</div>
						<img src="../img/more3.png" alt="" />
					</div>
				</div>	
					
				<div class="iptContainer">

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>企业名称：
						</div>
						<!-- <el-input v-model="schoolInfo.company_name" disabled placeholder="请输入企业名称"
							maxlength="50"></el-input> -->
							<div class="" style="width:577px;height: 40px;border: 1px solid #DCDFE6;background: #F6F7FB;border-radius: 4px;padding: 10px 20px;display: flex;align-items: center;justify-content: space-between;cursor:no-drop;">
								<div class="" style="font-size: 14px;color: #606266;">
									{{schoolInfo.company_name}}
								</div>
								<img src="../img/suo.png" alt="" style="width: 20px;height: 20px;"/>
							</div>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>企业标签：
						</div>
						<el-input v-model="cfeature" placeholder="例如：高新技术企业,专精特新小巨人企业" maxlength="50"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							活动时间：
						</div>
						<!-- <el-date-picker v-model="active_time" @change='timeChange()' type="datetimerange"
							start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
						</el-date-picker> -->

						<el-date-picker v-model="stime" @change='stimeChange' type="datetime" 
							:style="stime?'margin-right: 10px;':''" placeholder="请选择开始时间（默认待定）" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm">
						</el-date-picker>

						<el-date-picker v-model="etime" type="datetime" v-if='stime' placeholder="请选择结束时间（默认待定）"
							:picker-options="pickerOptions1" @change='etimeChange' format="yyyy-MM-dd HH:mm">
						</el-date-picker>

					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>集合/探访地址：
						</div>
						<div class="environment" @click="openDialogVisible"
							:style="active_address!==''?'color:#606266;display:block':'color:#c0c4cc;display:block'">
							{{active_address==''?'请选择工作地点':active_address}}
						</div>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>活动亮点：
						</div>
						<el-input type="textarea" autosize
							placeholder="例如：教育+AI探索者；强大的名师资源；数据驱动的精细化运营；高效的本地化运营；创始人及管理团队优势。"
							v-model="active_spot" maxlength="100" show-word-limit>
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>活动安排：
						</div>
						<el-input type="textarea" autosize placeholder="例如：以下为拟定安排，后续会根据具体情况略微调整
14:00-15:00
出发：集中乘车前往探访企业，随车老师讲解活动安排和注意事项。
15:00-16:00
欢迎仪式：企业代表欢迎致辞、合影留念。
企业参观：参观企业展厅、生产线、办公环境，讲解企业发展历程和部门分工。" v-model="active_intro" maxlength="200" show-word-limit>
						</el-input>
					</div>

					<div class="companyContainer" style="margin-bottom: 30px;">
						<div class="text">
							企业封面图：
						</div>

						<div class="company">
							<div class="top">
								<div class="" style="font-weight: 400;font-size: 14px;color: #C0C4CC;flex: 1;">
									请上传企业封面图
								</div>
								<div class="uplodadCompany1">
									<el-upload class="avatar-uploader1"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess"
										:before-upload="beforeAvatarUpload">
										<div class="uplodadCompany">
											<img src="../img/xiangji.png" alt="" />
											<div class="btn">
												企业封面图
											</div>
										</div>
									</el-upload>
								</div>
							</div>
							<div class="companyImg">
								<!-- <img :src="company_cover" alt="" v-if="company_cover" /> -->
								<div class="closeContainer" v-if="company_cover" style="position: relative;">
									<img v-if="company_cover" :src="company_cover" class="avatar"
										style="width: 195px !important;height: 120px !important;border-radius: 5px;">
									<img class="closeImg" src="../img/close1.png" alt="" @click.stop="delWeixin"
										style="width: 15px;height: 15px;position: absolute;right: 5px;top: 5px;cursor: pointer;border-radius: 50%;background: rgba(255, 255, 255, 0.8);padding: 2px;" />
								</div>
								<div v-else class=""
									style="width: 195px;height: 120px;background: #f9fbff;border-radius: 5px;text-align: center;line-height: 120px;margin-right: 15px;font-weight: 500;font-size: 18px;color: #BEC6D2;">
									企业封面图
								</div>
								<div class="">
									<!-- <span style="margin-bottom: 5px;">注意事项: </span> -->
									
									<span style="margin-bottom: 5px;">海报比例16:9，海报大小10M内</span>
									<span style="margin-bottom: 5px;">支持格式:JPG、PNG、JPEG</span>
								</div>
							</div>
						</div>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							活动名额：
						</div>
						<el-input type="number" v-model="allowed_number"  placeholder="例如：50人":max="2000"  @input="limitMax"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							参与对象：
						</div>
						<el-input v-model="allowed_person" placeholder="例如：双一流及普通本科" maxlength="20"></el-input>
					</div>

				</div>

				<div class="btnContainer">
					<el-button class="cancel" @click="cancel" v-if="isAmend">取消</el-button>
					<el-button type="primary" @click="submit">{{isAmend?'修改报名':'提交报名'}}</el-button>
				</div>
			</div>
		</div>




		<el-dialog :visible.sync="mapDialogVisible" title="选择地点" width="600px" :close-on-click-modal='false'
			:before-close="handleClose">
			<getMapLocation @selectLocation='selectLocation' @close='close' :isjobShadowing='true'></getMapLocation>
		</el-dialog>

	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	import getMapLocation from '../components/getMapLocation.vue'
	export default {
		data() {
			return {
				work_place: '',
				dialogVisible: false,



				cfeature: '',
				active_time: '',
				mapDialogVisible: false,

				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 86400000;
					}
				},

				active_spot: '',
				active_intro: '',
				company_cover: '',
				allowed_number: '',
				allowed_person: '',
				active_address: '',



				pickerOptions: {
					disabledDate(time) {
						const oneDay = 86400000;
						return time.getTime() < Date.now() - oneDay;
					}
				},
				pickerOptions1: {
					disabledDate: (time) => {
						const oneDay = 86400000;
						if(this.stime){
							return time.getTime() < Date.now() - oneDay;
						}else{
							return time.getTime() < Date.now() - oneDay;
						}
						
						// return time.getTime() < Date.now() - oneDay;
					}
				},
				stime: '',
				etime: '',
				
				isAmend:false
			};
		},
		components: {
			getMapLocation,
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		mounted() {
			this.getcreateExploring()

		},
		methods: {
			...mapMutations(['setIslogin']),
			limitMax(val){
				let numStr = val.replace(/[^\d]/g, '')
				    let num = Number(numStr)
				    // 2. 限制最大值999
				    if (num > 1999) {
				      numStr = '1999'
				    }
				    // 3. 输入0或空置空
				    if (num === 0) {
				      numStr = ''
				    }
				    this.allowed_number = Number(numStr)
			},
			delWeixin() {
				this.company_cover = ''
			},
			cancel(){
				this.$confirm('是否取消该探岗报名', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$util.post(
						"v2/user/delExloringByAdminId", {
							admin_id: this.schoolInfo.admin_id
						},
						(res) => {
							if (res.code == 200) {
								this.$message({
									message: '取消成功',
									type: 'success'
								});
								setTimeout(() => {
									let is_demo = sessionStorage.getItem('demo')
									if(is_demo){
										this.$router.push({
											path: '/meeting?demo='+is_demo,
										})
									}else{
										this.$router.push({
											path: '/meeting',
										})
									}
								}, 1000)
							}
						}
					);
				}).catch(() => {
				
				});
			},
			stimeChange() {
				this.etime = ''
			},
			openPDF() {
				window.open(
					'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/12/wanqiduijie.pdf', 
					'_blank')
			},
			getcreateExploring() {
				this.$util.post(
					"v2/user/getExloringList", {
						admin_id: this.schoolInfo.admin_id
					},
					(res) => {
						if (res.code == 200) {
							console.log(res)
							if (res.data) {
								this.cfeature = res.data.cfeature
								this.active_spot = res.data.active_spot
								this.active_intro = res.data.active_intro
								this.company_cover = res.data.company_cover
								this.allowed_number = res.data.allowed_number
								this.allowed_person = res.data.allowed_person
								this.active_address = res.data.active_address
								if(res.data.active_time!=''){
									if(res.data.active_time=='NaN-NaN-NaN NaN:NaN:NaN~NaN-NaN-NaN NaN:NaN:NaN'){
										
									}else{
										const [start, end] = this.splitTimeRange(res.data.active_time);
										// this.active_time = [new Date(start),new Date(end)]
										this.stime = new Date(start)
										this.etime = new Date(end)
									}
								}
								
								this.isAmend = true
							} else {
								if(this.schoolInfo&&this.schoolInfo.feature){
									this.cfeature = this.schoolInfo.feature
								}
								if (this.schoolInfo && this.schoolInfo.address_arr.length > 0) {
									let str = ''
									let e = this.schoolInfo.address_arr[0]
									str += e.work_province
									if (
										e.work_city == '北京市' ||
										e.work_city == '天津市' ||
										e.work_city == '上海市' ||
										e.work_city == '重庆市' ||
										e.work_city == '澳门特别行政区' ||
										e.work_city == '香港特别行政区'
									) {
										str += ''
									} else {
										str += e.work_city
									}
									console.log(str)
									str += e.work_county
									str += e.address
									this.active_address = str
								}
							}
						}
					})
			},
			etimeChange(){
				// console.log(new Date(this.stime))
				// console.log(new Date(this.etime))
				if(this.etime){
					if(new Date(this.stime)>=new Date(this.etime)){
						this.$message.error('开始时间需小于结束时间!');
						this.etime = ''
					}
				}
			},
			splitTimeRange(timeStr) {
				 if (typeof timeStr !== 'string') return ['', ''];
				  // 兼容 时分 / 时分秒两种格式
				  const reg = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?/g;
				  const list = timeStr.match(reg) || [];
				  return list.length >= 2 ? [list[0], list[1]] : ['', ''];
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB!');
					return
				}

				return isLt2M && img;
			},
			handleAvatarSuccess(res, file) {
				this.company_cover = file.response.data.fileUrl;
			},
			close() {
				this.mapDialogVisible = false
			},
			submit() {
				if (this.cfeature.trim() == '') {
					this.$message({
						type: 'error',
						message: '请输入企业标签'
					});
					return
				}
				if (this.stime&&this.etime == '') {
					this.$message({
						type: 'error',
						message: '请输入活动时间'
					});
					return
				}
				if (this.active_address.trim() == '') {
					this.$message({
						type: 'error',
						message: '请输入探访地址'
					});
					return
				}
				if (this.active_spot.trim() == '') {
					this.$message({
						type: 'error',
						message: '请输入活动亮点'
					});
					return
				}
				if (this.active_intro.trim() == '') {
					this.$message({
						type: 'error',
						message: '请输入活动安排'
					});
					return
				}
				if(this.stime != '' && this.etime != ''){
					if(this.stime.getTime() < Date.now()){
						this.$message.error('开始时间需大于当前时间!');
						return
					}
					if(this.etime.getTime() < Date.now()){
						this.$message.error('结束时间需大于当前时间!');
						return
					}
				}
				
				let obj = {
					admin_id: this.schoolInfo.admin_id,
					company_name: this.schoolInfo.company_name,
					cfeature: this.cfeature,
					active_spot: this.active_spot,
					active_intro: this.active_intro,
					company_cover: this.company_cover,
					allowed_number: this.allowed_number,
					allowed_person: this.allowed_person,
					active_address: this.active_address,
				}
				if(this.stime!==''&&this.etime!=''){
					obj.active_time = this.$getTime('-', 1, this.stime) + '~' + this.$getTime('-', 1, this
						.etime)
				}else{
					obj.active_time = ''
				}
				
					
				
				this.$util.post(
					"v2/user/createExploring", {
						...obj
					},
					(res) => {
						if (res.code == 200) {
							this.$message({
								message: '保存成功',
								type: 'success'
							});
							setTimeout(() => {
								let is_demo = sessionStorage.getItem('demo')
								if(is_demo){
									this.$router.push({
										path: '/meeting?demo='+is_demo,
									})
								}else{
									this.$router.push({
										path: '/meeting',
									})
								}
							}, 1000)
						}
					}
				);
			},
			$getTime(symbol = '-', status = 0, time = Date.now()) {
				let date = new Date(time)
				let Y = date.getFullYear() + symbol

				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + symbol
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

				let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
				let Minu = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
				let S = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
				switch (status) {
					case 0:
						return Y + M + D;
					case 1:
						return Y + M + D + H + Minu + S;
					default:
						break;
				}
			},
			timeChange(index) {
				// this.active_time = ''
				// if(index){
				// 	this.liveList[index].stime = this.$getTime('-',1,this.liveList[index].value1[0])
				// 	this.liveList[index].etime = this.$getTime('-',1,this.liveList[index].value1[1])
				// }else{
				// 	this.liveList[index].stime = ''
				// 	this.liveList[index].etime = ''
				// }
			},
			handleClose(done) {
				done();
			},

			openDialogVisible() {
				this.mapDialogVisible = true
			},

			selectLocation(e) {
				let str = ''
				if(e.work_province){
					str += e.work_province
					if (
						e.work_city.trim() == '北京市' ||
						e.work_city == '天津市' ||
						e.work_city == '上海市' ||
						e.work_city == '重庆市' ||
						e.work_city == '澳门特别行政区' ||
						e.work_city == '香港特别行政区'
					) {
						str += ''
					} else {
						str += e.work_city
					}
					str += e.work_county
					str += e.address
				}
				if(e.remark){
					str += e.remark
				}
				this.active_address = str
				this.mapDialogVisible = false
			},

		},

	};
</script>
<style>
	/* #jobShadowing .el-picker-panel__footer /deep/ .el-button{
		display: none !important;
	} */
	#jobShadowing .cancel{
		color: #AEAEAE !important;
		background: #ffffff !important;
		border-color: #d0d0d0 !important;
	}
	
	#jobShadowing .avatar-uploader1 .el-upload {
		border: none !important;
	}

	#jobShadowing .el-date-editor.el-input__inner {
		flex: 1 !important;
	}
</style>
<style lang="less" scoped>
	.closeContainer:hover .closeImg {
		display: inline-block;
	}
	.closeImg {
		display: none;
	}
	.container {
		width: 100%;
		padding: 0 40px;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.companyInfoIpt {
			padding: 20px 0 0 0;

			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}
			}

			.iptContainer {

				// .avatarContainer {
				// 	display: flex;
				// 	// align-items: center;
				// 	align-items: flex-start;
				// 	margin-bottom: 30px;

				// 	.text {
				// 		width: 100px;
				// 		display: flex;
				// 		align-items: center;
				// 		font-weight: 500;
				// 		font-size: 18px;
				// 		color: #333333;
				// 		margin-right: 20px;
				// 	}

				// 	.upload {
				// 		margin-right: 20px;
				// 	}

				// 	.uploadContainer {
				// 		display: flex;
				// 		align-items: center;

				// 		.uploadText {
				// 			width: 310px;
				// 			font-weight: 500;
				// 			font-size: 16px;
				// 			color: #999999;
				// 		}
				// 	}

				// }

				.ipt {
					width: 700px;
					display: flex;
					align-items: center;
					margin-bottom: 28px;

					.text {
						// width: 135px;
						width: 113px;
						display: flex;
						align-items: center;
						margin-right: 10px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						justify-content: flex-end;

						span {
							font-weight: 500;
							font-size: 14px;
							color: #000;
						}
					}

					.el-input {
						flex: 1 !important;
					}

					.el-select {
						flex: 1 !important;
					}

					.el-textarea {
						flex: 1 !important;
					}
				}

			}

			.btnContainer {
				width: 700px;
				display: flex;
				justify-content: flex-end;
				margin-bottom: 60px;

				// .el-button--primary {
				// 	background-color: #0084FF !important;
				// 	border-color: #0084FF !important;
				// 	// border-radius: 10px !important;
				// }
			}
		}


	}

	.companyContainer {
		display: flex;
		align-items: flex-start;
		width: 700px;

		.text {
			width: 113px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-weight: 400;
			font-size: 14px;
			color: #000;
			margin-right: 10px;
		}

		.el-input {
			flex: 1 !important;
		}

		.company {
			flex: 1;
			background: #FFFFFF;
			border-radius: 5px;
			border: 1px solid #DCDFE6;
			box-sizing: border-box;
			padding: 15px 15px 20px 15px;

			.top {
				display: flex;
				align-items: center;
				width: 100%;
				border-bottom: 1px solid #dcdcdc69;
				margin-bottom: 20px;

				padding: 0 5px 15px 5px;

				.uplodadCompany1 {}

				.uplodadCompany {
					display: flex;
					align-items: center;
					font-size: 0;
					margin-left: 10px;

					img {
						width: 20px;
						height: 20px;
						margin-right: 12px;
					}

					.btn {
						font-weight: 500;
						font-size: 14px;
						color: #3A84E9;
					}
				}
			}

			.companyImg {
				display: flex;
				align-items: center;
				// padding: 0 15px;
				font-size: 0;

				img {
					width: 195px;
					height: 120px;
					margin-right: 15px;
				}

				div {
					font-weight: 500;
					font-size: 14px;
					color: #999;
					display: flex;
					// align-items: center;
					justify-content: space-between;
					flex-direction: column;
				}

			}
		}
	}

	.addNewContainer {
		width: 700px;
		display: flex;
		// align-items: flex-end;
		justify-content: flex-end;
		margin-bottom: 30px;

		.addNew {
			width: 600px;
			height: 60px;
			background: #f9fbff;
			border-radius: 5px;

			text-align: center;
			line-height: 60px;
			font-weight: 500;
			font-size: 14px;
			color: #3A84E9;
			cursor: pointer;
		}
	}
	
	.bg{
		width:700px;
		height: 120px;
		background-image: url(../img/bg4.png) ;
		background-repeat: no-repeat;
		cursor: pointer;
		margin-bottom: 30px;
		box-sizing: border-box;
		padding: 30px 25px;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		.title{
			color: #119876;
			font-size: 20px;
			font-weight: bold;
			// margin-bottom: 10px;
		}
		.subheading{
			font-size: 0;
			display: flex;
			align-items: center;
			div{
				color: #606266;
				font-size: 14px;
				margin-right: 5px;
			}
			img{
				width: 10px;
				height: 10px;
			}
		}
	}
</style>

<style>
	
	/* #register .el-input__inner {
		font-size: 16px;
	} */

	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	.avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatar-uploader-icon {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	.avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}



	.environment {
		border: 1px solid #DCDFE6;
		flex: 1;
		background-color: #FFF;
		color: #606266;
		height: 40px;
		padding: 0 15px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 40px;
		cursor: text;

		overflow: hidden;

		text-overflow: ellipsis;

		white-space: nowrap;
		width: 500px;
	}
	
	
</style>